angular.module('common',
    [
        'common.directives.teethConverter',
        'common.directives.focus',
        'common.directives.urlencode',
        'common.directives.recompile',
        'common.directives.buttonSliderMenu',
        'common.directives.omSpinner',
        'common.directives.omStatCounter',
        'common.directives.appLoadingAnimation',
        'common.directives.omNumericTextBox',
        'common.directives.omAutocomplete',
        'common.directives.omDatePicker',
        'common.directives.meshViewer',
        'common.directives.inView',
        'common.directives.scrollIntoViewIf',
        'common.directives.slideInBounce',
        'common.directives.googleTranslate',
        'common.directives.popupMap',
        'common.directives.inlineEditText',
        'common.directives.inlineEditDropdown',
        'common.directives.searchTermHighlight',
        'common.directives.goBackButton'
    ]);
